module.exports = "/_next/static/images/neutral-f73208ce24fe10fc9ed12447507fa04b.png";